import React from 'react';

import DestinationMarker from './icons/destination-marker';
import DriverMarker from './icons/driver-marker';
import StoreMarker from './icons/store-marker';
import StoreMarkerActiveSvg from './icons/store-marker-active';
import StoreMarkerDisabledSvg from './icons/store-marker-disabled';
import StoreMarkerFavorite from './icons/store-marker-fav';
import StoreMarkerFavClosed from './icons/store-marker-fav-closed';
import StoreMarkerInactiveSvg from './icons/store-marker-inactive';
import UserMarker from './icons/user-marker';
import { IMarker, IMarkerInput, MarkerTypes } from './types';

// this is used just for web as on web we don't have any issues with SVG images
export const deriveMarkerIcon = (type: MarkerTypes): React.ReactNode => {
  switch (type) {
    case MarkerTypes.User:
      return <UserMarker />;
    case MarkerTypes.StoreActive:
      return <StoreMarker />;
    case MarkerTypes.StoreInActive:
      return <StoreMarkerActiveSvg />;
    case MarkerTypes.StoreSelectedInactive:
      return <StoreMarkerInactiveSvg />;
    case MarkerTypes.StoreDisabled:
      return <StoreMarkerDisabledSvg />;
    case MarkerTypes.StoreFavClosed:
      return <StoreMarkerFavClosed />;
    case MarkerTypes.StoreFavOpen:
      return <StoreMarkerFavorite />;
    case MarkerTypes.Driver:
      return <DriverMarker />;
    case MarkerTypes.Destination:
      return <DestinationMarker />;

    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export const checkSingleUseMarker = (type: MarkerTypes): boolean =>
  [MarkerTypes.User, MarkerTypes.Driver, MarkerTypes.Destination].includes(type);

// this is just for mobile apps as after some research most of the performance issues was caused by SVG images
export const getKeyForMarkerInput = (
  { type, location }: IMarkerInput,
  isSingleUseMarker: boolean
): string => (isSingleUseMarker ? type : `${location.lat}${location.lng}`);

export const generateMarker = ({ type, location, onPress }: IMarkerInput): IMarker => {
  const isSingleUseMarker = checkSingleUseMarker(type);
  const key = getKeyForMarkerInput({ type, location }, isSingleUseMarker);
  return {
    key,
    location,
    icon: deriveMarkerIcon(type),
    onPress,
    type,
    preventMarkerPress: isSingleUseMarker,
  };
};
